import { render, staticRenderFns } from "./CreateEmergency.vue?vue&type=template&id=b604ae7a&"
import script from "./CreateEmergency.vue?vue&type=script&lang=js&"
export * from "./CreateEmergency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports